/**
 * Return the key for a keyboard event. Note that this only implements a small subset
 * of named keys. It will always return the lowercase version for letters.
 *
 * @param {KeyboardEvent.key, KeyboardEvent.keyCode}
 */
export default function getKey({ key, keyCode }) {
    if (key) {
        return (
            {
                // These are renamed in the spec, but Firefox
                // still have the old names (and warns about it)
                Del: 'Delete',
                Esc: 'Escape',
                Left: 'ArrowLeft',
                Up: 'ArrowUp',
                Right: 'ArrowRight',
                Down: 'ArrowDown',
            }[key] || key
        );
    }

    key = {
        9: 'Tab',
        13: 'Enter',
        27: 'Escape',
        33: 'PageUp',
        34: 'PageDown',
        35: 'End',
        36: 'Home',
        37: 'ArrowLeft',
        38: 'ArrowUp',
        39: 'ArrowRight',
        40: 'ArrowDown',
        46: 'Delete',
    }[keyCode];

    if (key) {
        return key;
    }

    const char = String.fromCharCode(keyCode);
    if (/[0-9a-z]/i.test(char)) {
        return char.toLowerCase();
    }

    return 'Unidentified';
}



// WEBPACK FOOTER //
// ./lib/getKey.js